import React from "react";
import ReactDOM from "react-dom";
import "font-awesome/css/font-awesome.css";
import "bootstrap/js/dist/dropdown";
import { preloadJarvisBaseSettings } from "./Jarvis/JarvisServices/JarvisBaseSettingsService";

const rootEl = document.getElementById("root");

// Create a reusable render method that we can call more than once
let render = () => {
  // Dynamically import our main App component, and render it
  preloadJarvisBaseSettings()
    .then(() => {
      const Prerequisites = require("Jarvis/JarvisApp/Prerequisites").default;
      ReactDOM.render(<Prerequisites />, rootEl);
    })
    .catch((err) => {
      console.error("Failed to load base settings:", err);
    });
};

if (module.hot) {
  module.hot.accept("Jarvis/JarvisApp/Prerequisites", () => {
    preloadJarvisBaseSettings()
      .then(() => {
        const Prerequisites = require("Jarvis/JarvisApp/Prerequisites").default;
        render(<Prerequisites />, rootEl);
      })
      .catch((err) => {
        console.error("Failed to load base settings:", err);
      });
  });
}

render();
